export default "__VITE_ASSET__Bzdbc$P5__"